import React from 'react';
import {useTheme} from '../../../../../utils/theming/themeProvider';
import {CaretProps} from '../tooltip_types.web';
import {caretStyles} from '../tooltip_styles.web';

export default ({align, backgroundColor, position, style}: CaretProps) => {
  const {colors, fontStyles} = useTheme();

  const top =
    (position === 'left' || position === 'right') && align === 'left'
      ? 4
      : position === 'bottom'
      ? 0
      : undefined;
  const bottom =
    (position === 'left' || position === 'right') && align === 'right'
      ? 4
      : position === 'top'
      ? 0
      : undefined;

  const left =
    (position === 'top' || position === 'bottom') && align === 'left'
      ? 4
      : position === 'right'
      ? 0
      : undefined;
  const right =
    (position === 'top' || position === 'bottom') && align === 'right'
      ? 4
      : position === 'left'
      ? 0
      : undefined;

  const isHorizontalLayout = position === 'left' || position === 'right';

  return (
    <div
      // @ts-ignore
      style={{
        ...caretStyles.container,
        backgroundColor: backgroundColor ? backgroundColor : colors.neutral1000,
        transform: isHorizontalLayout ? 'rotate(45deg)' : `rotate(45deg)`,
        borderRadius: 1,
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        marginLeft:
          isHorizontalLayout && position === 'left'
            ? '-4px'
            : !isHorizontalLayout
            ? position === 'top'
              ? '5px'
              : '5px'
            : '0',
        marginRight:
          isHorizontalLayout && position === 'right'
            ? '-4px'
            : !isHorizontalLayout
            ? position === 'top'
              ? '5px'
              : '5px'
            : '0',
        marginTop: !isHorizontalLayout && position === 'top' ? '-4px' : '0',
        marginBottom:
          !isHorizontalLayout && position === 'bottom' ? '-5px' : '0',
        ...style,
      }}
    />
  );
};
